import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { getProfile } from "@/api/endpoints/auth";
import { closeWebview } from "@/app/back";
import { ROUTES } from "@/app/routes";
import { DocumentLinkRow } from "@/components/ui/DocumentLinkRow";
import { InfoCard } from "@/components/ui/InfoCard";
import { InfoRow } from "@/components/ui/InfoRow";
import { InfoRowSkeleton } from "@/components/ui/InfoRowSkeleton";
import { ScreenHeader } from "@/components/ui/ScreenHeader";
import { ScreenMessage } from "@/components/ui/ScreenMessage";
import { describeFailure } from "@/lib/failure";

export default function AccountSettingPage() {
  const navigate = useNavigate();
  const profile = useQuery({ queryKey: ["auth", "me"], queryFn: () => getProfile() });

  const failure = profile.isError ? describeFailure(profile.error) : null;

  return (
    <>
      <ScreenHeader title="บัญชีผู้ใช้งาน" />
      <main className="safe-bottom flex-1 bg-white px-[22px] pt-[26px] tracking-[-0.011em]">
        {failure === null ? (
          <>
            <InfoCard title="ข้อมูลส่วนตัว">
              {profile.isPending
                ? Array.from({ length: 5 }, (_unused, index) => (
                    <InfoRowSkeleton key={index} />
                  ))
                : null}

              {profile.data === undefined ? null : (
                <>
                  <InfoRow label="ชื่อ" value={profile.data.firstName} />
                  <InfoRow label="นามสกุล" value={profile.data.lastName} />
                  <InfoRow label="เลขบัตรประชาชน" value={profile.data.idCard} />
                  <InfoRow label="เบอร์โทรศัพท์" value={profile.data.mobile} />
                  <InfoRow label="อีเมล" value={profile.data.userEmail} />
                </>
              )}
            </InfoCard>

            {/* The flow opens with a PIN check, ported from native InputPin. */}
            <div className="mt-[26px]">
              <DocumentLinkRow
                label="เปลี่ยนที่อยู่จัดส่งเอกสาร"
                onPress={() => {
                  void navigate(ROUTES.settings.accountInputPin);
                }}
              />
            </div>
          </>
        ) : (
          <ScreenMessage
            title={failure.title}
            description={failure.description}
            actionLabel={failure.action === "retry" ? "ลองใหม่" : "กลับ"}
            onAction={() => {
              if (failure.action === "retry") {
                void profile.refetch();
                return;
              }
              closeWebview();
            }}
          />
        )}
      </main>
    </>
  );
}
